// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"aa168e338c932fadbc73","655":"0a77bb1c50674a76cdaf"}[chunkId] + ".js";
};